import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Flock silhouette uses the ★1 tier art. The active rendering
// for Shadow Crane goes through TIERED_GLYPHS (see tieredGlyphs.ts)
// which routes ★2/★3 to the richer tier images extracted from
// assets/shadow_crane_3tier.png. (The unit was renamed from "Crane
// Flock"; the glyph key + filenames stayed `flock` to avoid churn.)
// The generic `crane` glyph stays free for fallback rendering
// (UnitGlyph / BattleScreen / Gallery use it as the safety net when
// a unit's glyph key is missing).
export const Flock = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/flock-1.png" size={size} alt="shadow crane" />
)
